export default {
  mapForm: {
    placesAndDirections: 'Vyhledat a přejít',
    isochrones: 'Dosah',
    uploadedContentRendered: 'Nahraný obsah zobrazen',
    errorRenderingContentUploaded: 'Chyba při vykreslování nahraného obsahu. Zkontrolujte formát a obsah souboru'
  }
}
